import { getTagsOptions } from '@metto/http-clients/api';
import { useQuery } from '@metto/http-clients/react-query';

export const useTagsQuery = () => {
  return useQuery({
    ...getTagsOptions(),
    select: data => data?.tags,
    // Throw errors to trigger route error boundary - app can't function without tags
    throwOnError: true
  });
};
